module.exports = __webpack_public_path__ + "cccb897485813c7c256901dbca54ecf2.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Bold.woff2
// module id = 964
// module chunks = 0